import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { MissingTimesheetData } from '../api/types';

// Hired workers on ended shifts with no timesheet data, grouped by shift.
const useMissingTimesheetQueue = (agencyId: number) =>
  useQuery<MissingTimesheetData>({
    queryKey: dashboardV2QueryKeys.missingTimesheet(agencyId),
    queryFn: () => dashboardV2Client.getMissingTimesheet(agencyId),
    enabled: agencyId != null,
    staleTime: 30_000,
  });

export default useMissingTimesheetQueue;
